import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.AccountPastDueOptOut,
  { key: LocationVarKey.InformPastDue1, hideIf: IS_EQUAL(LocationVarKey.AccountPastDueOptOut, "1") },
  { key: LocationVarKey.InformPastDue2, hideIf: IS_EQUAL(LocationVarKey.AccountPastDueOptOut, "1") },
  LocationVarKey.AccountInactiveOptOut,
  { key: LocationVarKey.InformInactive1, hideIf: IS_EQUAL(LocationVarKey.AccountInactiveOptOut, "1") },
  { key: LocationVarKey.InformInactive2, hideIf: IS_EQUAL(LocationVarKey.AccountInactiveOptOut, "1") }
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Past Due Account
      </PageHeader>

      <SwitchRow {...page} keyName={LocationVarKey.AccountPastDueOptOut} label="Do NOT inform tenants that they are past due" />
      <TextAreaRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.AccountPastDueOptOut, "1")}
        marginTop
        label=" Message 1"
        keyName={LocationVarKey.InformPastDue1}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.AccountPastDueOptOut, "1")}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.InformPastDue2}
        enableSwitchVar={LocationVarKey.InformPastDue2Enabled}
      />

      <SectionHeader {...page}> Inactive Account </SectionHeader>
      <SwitchRow {...page} keyName={LocationVarKey.AccountInactiveOptOut} label="Do NOT inform tenants that they are inactive" />
      <TextAreaRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.AccountInactiveOptOut, "1")}
        marginTop
        label=" Message 1"
        keyName={LocationVarKey.InformInactive1}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.AccountInactiveOptOut, "1")}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.InformInactive2}
        enableSwitchVar={LocationVarKey.InformInactive2Enabled}
      />
    </>
  );
}
